<template>
  <div v-if="emailTemplate">
    <h1>Email template</h1>
    <v-btn :to="{ name: 'emailTemplatesSales' }"
      ><v-icon>chevron_left</v-icon> Email templates</v-btn
    >
    <v-btn :to="{ name: 'emailTemplateRevisionSalesAdd' }"
      ><v-icon>add</v-icon> Revision</v-btn
    >
    <v-checkbox
      label="Archived"
      v-model="emailTemplate.archived"
      @change="updateEmailTemplateArchived"
    />
    <v-checkbox
      label="Selected by default"
      v-model="emailTemplate.selectedByDefault"
      @change="updateEmailTemplateSelectedByDefault"
    />
    <v-data-table
      :pagination.sync="pagination"
      :headers="headers"
      :items="computedEmailTemplateRevisions"
      class="elevation-1"
      v-if="computedEmailTemplateRevisions"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <v-btn
              :to="{
                name: 'emailTemplateRevisionSales',
                params: { id: $route.params.id, revisionid: props.item.id }
              }"
              small
              >{{ props.item.id }}</v-btn
            >
          </td>
          <td>{{ props.item.subject }}</td>
          <td>{{ props.item.instructedValue }}</td>
          <td>{{ props.item.quoteTypesListed }}</td>
          <td>{{ props.item.sendAutomatically }}</td>
          <td>{{ props.item.scheduleValue }}</td>
          <td>
            <span v-if="props.item.published" style="color: red">{{
              props.item.published | formatDateTime
            }}</span>
            <span v-if="!props.item.published" style="color: green"
              >Unpublished</span
            >
            <span
              v-if="
                emailTemplate.emailTemplateRevision &&
                props.item.id == emailTemplate.emailTemplateRevision.id
              "
              style="background: green; color: white"
              >ACTIVE</span
            >
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
import { instructedList } from "@/util/helpers";
export default {
  name: "EmailTemplate",
  metaInfo() {
    return {
      title: "Email Template",
      titleTemplate: "%s - Sales - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  computed: {
    computedEmailTemplateRevisions() {
      if (!this.emailTemplate) {
        return undefined;
      }
      if (!this.emailTemplate.emailTemplateRevisions) {
        return undefined;
      }
      return this.emailTemplate.emailTemplateRevisions.map((et) => {
        const instructedValue = this.instructeds.find(
          (i) => et.instructed == i.id
        ).name;
        const quoteTypesListed = et.quoteTypes
          .map((qt) => qt.abbreviation)
          .join(", ");
        const scheduleValue = et.sendAutomatically ? et.schedule : "Manual";
        return { ...et, instructedValue, quoteTypesListed, scheduleValue };
      });
    }
  },
  data() {
    return {
      quoteTypes: null,
      emailTemplate: null,
      headers: [
        {
          text: "Id",
          value: "id"
        },
        {
          text: "Subject",
          value: "subject"
        },
        {
          text: "Instructed",
          value: "instructed"
        },
        {
          text: "Quote types",
          sortable: false
        },
        {
          text: "Send automatically",
          value: "sendAutomatically"
        },
        {
          text: "Schedule",
          value: "schedule"
        },
        {
          text: "Published",
          value: "published"
        }
      ],
      pagination: {
        rowsPerPage: -1,
        sortBy: "name",
        descending: false
      },
      instructeds: null
    };
  },
  methods: {
    async fetchQuoteTypes() {
      const response = await nbmlaw.get(`/cors/admin/sales/quoteTypes`);
      // console.log(response.data);
      this.quoteTypes = response.data;
    },
    async fetchEmailTemplate() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/emailTemplates/${this.$route.params.id}`
      );
      // console.log(response.data);
      this.emailTemplate = response.data;
    },
    async updateEmailTemplateArchived() {
      await nbmlaw.put(
        `/cors/admin/sales/emailTemplates/${this.$route.params.id}/archived`,
        { archived: this.emailTemplate.archived }
      );
    },
    async updateEmailTemplateSelectedByDefault() {
      await nbmlaw.put(
        `/cors/admin/sales/emailTemplates/${this.$route.params.id}/selectedByDefault`,
        { selectedByDefault: this.emailTemplate.selectedByDefault }
      );
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        if (this.$route.params.id) {
          this.fetchEmailTemplate();
        }
      }
    }
  },
  created() {
    this.fetchQuoteTypes();
    this.instructeds = instructedList();
  }
};
</script>
